import { handleActions } from 'redux-actions';
import { initState } from '../../../redux/models';
import * as actionType from './actionType';

export default handleActions(
  {
    //更新信息
    [actionType.YH_LIFE_UPDATA]: (state, { data }) => {
      const newState = { ...state, ...data };
      return newState;
    },
    [actionType.YH_LIFE_UPDATA_FILE]: state => {
      const newState = { ...state, modalTuttonLoading: false, tableLoading: false };
      return newState;
    },
  },
  initState,
);
